import Vue from 'vue'
// import Vuetify from 'vuetify/lib/framework'
import Vuetify from 'vuetify/lib'
// import {en, ja} from "vuetify/es5/locale"
import {en, ja} from "vuetify/lib/locale"

// import "@/styles/variables.scss"

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: {
      ja, en
    },
    current: "ja"
  },
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        // primary: "#770b15", // #E53935
        // primary: "#6c9cce"
        // primary: "#005AFF"
        primary: "#396ed0"
      },
    },
  },
})
